<template>
  <button class="normal-button" :style="style">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "NormalButton",

  props: {
    bgColor: {
      type: String,
      default: "black"
    },

    color: {
      type: String,
      default: "white"
    },

    fullWidth: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    style() {
      return this.colorStyle + this.width;
    },

    colorStyle() {
      return `background: ${this.bgColor}; color: ${this.color};`;
    },

    width() {
      return this.fullWidth ? "width: 100%;" : "width: auto";
    }
  }
};
</script>

<style lang="scss" scoped>
.normal-button {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 0.9rem;

  &:hover {
    opacity: 0.7;
  }
}
</style>
